import React, { useState, useEffect } from 'react';
import { useConfig } from '../contexts/ConfigContext';
import './Footer.css';

const Footer = () => {
    const { config, loading } = useConfig();
    const [isInIframe, setIsInIframe] = useState(false);

    useEffect(() => {
        // Проверяем, загружена ли страница в iframe
        setIsInIframe(window.self !== window.top);
    }, []);

    // Не показываем Footer, если страница в iframe
    if (isInIframe) {
        return null;
    }

    if (loading || !config) {
        return null;
    }

    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-left">
                        <a href={config.website} target="_blank" rel="noopener noreferrer">
                            <div className="logo-placeholder">{config.name}</div>
                        </a>
                    </div>

                    <div className="footer-middle">
                        <p>{config.phone}</p>
                        <p>{config.email}</p>
                        <p>{config.address}</p>
                    </div>

                    <div className="footer-right">
                        <p><strong>Система управления группами</strong></p>
                        <p>ОГРН: {config.ogrn}</p>
                        <p>ИНН: {config.inn}</p>
                        <p>КПП: {config.kpp}</p>
                    </div>

                    <div className="footer-middle">
                        <a href={config.privacyPolicyUrl} target="_blank" rel="noopener noreferrer">
                            <p>Политика конфиденциальности</p>
                        </a>
                        <a href={config.website} target="_blank" rel="noopener noreferrer">
                            <p>Официальный сайт образовательной организации</p>
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;

